import React from 'react';

const CloseIcon = () => {
	return (
		<svg
			data-testid='close'
			fill='none'
			height='24'
			viewBox='0 0 24 24'
			width='24'
		>
			<rect
				fill='#F2F2F2'
				height='24'
				rx='12'
				width='24'
			/>
			<path
				d='M11.3782 12L7 7.6245L7.62489 7L12 11.3724L16.3751 7L17 7.6245L12.6218 12L17 16.3755L16.3751 17L12 12.6276L7.62489 17L7 16.3755L11.3782 12Z'
				fill='#2E2E6B'
			/>
		</svg>
	);
};

export default CloseIcon;
